import { isNullOrUndefined } from 'util';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
import { CustomReuseStrategy } from './reuse-strategy';
@Injectable({
  providedIn: 'root'
})
export class TokenExpireService {
  constructor(
    private EncrdecrService: EncrdecrService,
    private router: Router,
  ) { }

  LogoutUser() {
    debugger;
    const CompanyName: string = environment.CompayName;
    var G_UserType = parseInt(
      this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
    ); //Session_UserType
    const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
    var SB_Session = sessionStorage.getItem('ihjt45h45=p'); //added by adarsh
    var CompanyLogo = sessionStorage.getItem('lkighty445dh=='); //added by adarsh
    const sessionvalue = sessionStorage.getItem('lkighty445dh==IsSignUp'); //added by adarsh 04032025
    //GDOM-395
    let UL = sessionStorage.getItem('F44sGAGh2xwkpUL');
    let a6 = sessionStorage.getItem('lkighty445dh==6');
    let a7 = sessionStorage.getItem('lkighty445dh==7');
    let QR = sessionStorage.getItem('lkighty445dh==QR');
    let Whs = sessionStorage.getItem('lkighty445dh==WhatsAppQR');
    let Wh = sessionStorage.getItem('lkighty445dh==WhatsAppLink');
    let Fa = sessionStorage.getItem('lkighty445dh==FacebookLink');
    let Li = sessionStorage.getItem('lkighty445dh==LinkedInLink');
    let Tw = sessionStorage.getItem('lkighty445dh==TwitterLink');
    let In = sessionStorage.getItem('lkighty445dh==InstagramLink');
    let rr = sessionStorage.getItem('ihjt45h45=t');
    let abc = sessionStorage.getItem('lkighty445dh==Disclaimer');

    sessionStorage.clear();
    localStorage.clear();

    sessionStorage.setItem('lkighty445dh==IsSignUp', sessionvalue); //added by adarsh 04032025
    sessionStorage.setItem('F44sGAGh2xwkpUL', UL);
    sessionStorage.setItem('lkighty445dh==6', a6);
    sessionStorage.setItem('lkighty445dh==7', a7);
    sessionStorage.setItem('lkighty445dh==QR', QR);
    sessionStorage.setItem('lkighty445dh==WhatsAppQR', Whs);
    sessionStorage.setItem('lkighty445dh==WhatsAppLink', Wh);
    sessionStorage.setItem('lkighty445dh==FacebookLink', Fa);
    sessionStorage.setItem('lkighty445dh==LinkedInLink', Li);
    sessionStorage.setItem('lkighty445dh==TwitterLink', Tw);
    sessionStorage.setItem('lkighty445dh==InstagramLink', In);
    sessionStorage.setItem('ihjt45h45=t', rr);
    sessionStorage.setItem('lkighty445dh==Disclaimer', abc);
    if (G_UserType && CompanyName == 'IFA') {
      debugger;
      sessionStorage.setItem('ihjt45h45=p', SB_Session); //added by adarsh
      sessionStorage.setItem('lkighty445dh==', CompanyLogo); //added by adarsh
    } else {
      debugger;
      sessionStorage.setItem('lkighty445dh==', CompanyLogo); //added by adarsh
    }
    setTimeout(() => {
      if (CompanyName == 'IFA') {
        if (G_UserType == 3) {
          this.router.navigateByUrl('/login/investor');
        } else {
          this.router.navigateByUrl('/login', { replaceUrl: true }).then(() => {
            //  clear all cached routes
            const reuseStrategy = this.router.routeReuseStrategy as CustomReuseStrategy;
            reuseStrategy.clearAllRoutes();
          });
        }
      } else {
        // this.SetCompanyLogo();
        if (G_UserType == 2) {
          this.router.navigateByUrl('/login');
        } else {
          this.router.navigateByUrl('/login/investor');
        }
      }
    }, 350);
  }

  // SetCompanyLogo(){
  //   const CompanyName: string = environment.CompayName;
  //   switch (CompanyName) {
  //     case "AU":
  //       sessionStorage.setItem("logo", "../../assets/images/Logo_AUBank.svg");
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("4")
  //       );
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "1");
  //       break;
  //     case "Mahindra":
  //       //../../assets/images/MahindraLogoTriangle.svg
  //       sessionStorage.setItem(
  //         "logo",
  //         "../../assets/images/MahindraLogoTriangle.svg"
  //       );
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("2")
  //       );
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "0");
  //       break;
  //     case "YesSecurities":
  //       sessionStorage.setItem(
  //         "logo",
  //         "../../assets/images/YesSecuritiesLogo.svg"
  //       );
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("11")
  //       );
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "0");
  //       break;

  //     case "SPA":
  //       sessionStorage.setItem("logo", "../../assets/images/SPA_Logo.svg");
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("13")
  //       );
  //       sessionStorage.setItem("Abodhj#@jdkd/%^ysudsh&#&shdj@#$", "13");
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "0");
  //       break;
  //     case "investedu":
  //       sessionStorage.setItem(
  //         "logo",
  //         "../../assets/images/investedu_Logo.svg"
  //       );
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("14")
  //       );
  //       sessionStorage.setItem("Abodhj#@jdkd/%^ysudsh&#&shdj@#$", "14");
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "0");
  //       break;
  //     case "NSDL":
  //       sessionStorage.setItem("logo", "../../assets/images/NSDL_Logo.svg");
  //       sessionStorage.setItem(
  //         "Abodhj#@jdkd/%^82ncdbcnggshd!@#$",
  //         this.EncrdecrService.setEncr("15")
  //       );
  //       sessionStorage.setItem("Abodhj#@jdkd/%^ysudsh&#&shdj@#$", "15");
  //       sessionStorage.setItem("Mnuoisns6wqgswj2$#", "0");
  //       break;
  //     case 'Alankit':
  //       sessionStorage.setItem('logo', '../../assets/images/Alankit_logo.svg');
  //       sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("16"));
  //       sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', "16");
  //       sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
  //     break;
  //     case 'Religare':
  //       sessionStorage.setItem('logo', '../../assets/images/religare-ai.png');
  //       sessionStorage.setItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$', this.EncrdecrService.setEncr("17"));
  //       sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', "17");
  //       sessionStorage.setItem('Mnuoisns6wqgswj2$#', "0");
  //     break;
  //     }
  // }
}
